<template>
  <div>
    <Loading v-if="loading" />

    <div v-else>
      <Title small> Mais Recentes </Title>

      <v-row v-if="items.length">
        <v-col
          class="py-0"
          cols="12"
          sm="6"
          lg="12"
          v-for="({ title, video, to }, keyItems) in items"
          :key="keyItems"
        >
          <v-card class="mt-6 item" :to="to" flat>
            <v-row class="my-0">
              <v-col cols="5" class="py-0">
                <img
                  :src="`//img.youtube.com/vi/${getYoutubeCode(
                    video
                  )}/hqdefault.jpg`"
                  alt="Fotos e Eventos"
                  class="d-block item-img"
                />
              </v-col>
              <v-col cols="7" class="pl-0 py-2">
                <div
                  class="
                    text-caption text-md-h6
                    grey--text
                    text--darken-4
                    font-weight-bold
                  "
                >
                  <div class="item-title">
                    {{ title }}
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <v-col v-if="items.length == 4" class="text-right mt-4" cols="12">
          <v-btn color="primary" depressed :to="path"> Veja Mais </v-btn>
        </v-col>
      </v-row>

      <v-alert v-else class="mt-6" type="info">
        Nenhum item encontrado.
      </v-alert>
    </div>
  </div>
</template>

<script>
import Loading from "./Loading.vue";
import Title from "./Title.vue";
import { formatToURL } from "../../utils/formatToURL";
import { getYoutubeCode } from "../../utils/getYoutubeCode";

const _config = {
  mod: "videos",
  path: "/imprensa/videos",
};

export default {
  props: {
    itemId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    loading: true,
    items: [],
    path: _config.path,
  }),
  created() {
    this.get();
  },
  watch: {
    page() {
      this.get();
    },
    $route() {
      this.get();
    },
  },
  methods: {
    getYoutubeCode,
    formatDate(date) {
      return new Intl.DateTimeFormat("pt-BR", { dateStyle: "medium" })
        .format(new Date(date.replace(" ", "T")))
        .replaceAll(" de", "")
        .replaceAll(".", "");
    },
    get() {
      const params = {
        itemsPerPage: 5,
      };

      this.loading = true;

      var i = false;

      this.$rest(_config.mod)
        .get({
          params,
          keepCache: true,
          save: (state, data) => {
            const items = [];
            data.map(({ id, title, video }, index) => {
              if (id == this.itemId) i = true;

              if ((id != this.itemId && i && index <= 4) || (!i && index <= 3))
                items.push({
                  title,
                  video,
                  to: `${this.path}/${formatToURL(title)}-${id}`,
                });
            });
            this.items = items;
          },
        })
        .then(() => (this.loading = false));
    },
  },
  components: {
    Loading,
    Title,
  },
};
</script>

<style lang="scss" scoped>
.item {
  .item-img {
    aspect-ratio: 16 / 9;
    object-fit: cover;
    -o-object-fit: cover;
    width: 100%;
  }
  .item-title {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
